import React, { useMemo, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { AdminLayout } from '../adminLayout';
import { IntlMessages } from '../../../helper/langHelper';
import { getClustersFlowList } from '../../../services/admin/clustersFlow';
import { UsersContainer, UsersHeader, LoaderWrapper, IconButton } from '../users/Users.styles';
import { Table } from '../../../components/uielements/table';
import { PrimaryButton } from '../users/modals/UserPromoteModal.styles';
import ClusterFlowCreateAndUpdateModal from './modals/Clusterflowcreateandupdatemodal';
import { useNavigate } from 'react-router-dom';

const ClustersFlow = () => {
  const [page, setPage] = useState(0);
  const [perPage] = useState(10);
  const [editClusterFlowData, setEditClusterFlowData] = useState(null);
  const [addClusterFlowData, setAddClusterFlowData] = useState(false);

  const { data, isLoading, isError } = useQuery({
    queryKey: ['adminClustersFlow', page, perPage],
    queryFn: () => getClustersFlowList(page, perPage),
  });

  const navigate = useNavigate();

  const tableData = data ?? [];
  const total = data?.total ?? 0;

  const columns = useMemo(
    () => [
      {
        Header: <IntlMessages id="table.col.name" defaultMessage="Flow Name" />,
        accessor: 'name',
        width: '20%',
      },
      {
        Header: <IntlMessages id="table.col.description" defaultMessage="Description" />,
        accessor: 'description',
        width: '40%',
      },
      {
        Header: <IntlMessages id="table.col.region" defaultMessage="Region" />,
        accessor: 'regionId.regionName',
        width: '12%',
      },
      {
        Header: <IntlMessages id="table.col.precinct" defaultMessage="Precinct" />,
        accessor: 'precinctId.precinctName',
        width: '12%',
      },
      {
        Header: <IntlMessages id="table.col.actions" defaultMessage="Actions" />,
        accessor: 'actions',
        isAction: true,
        width: '20%',
      },
    ],
    []
  );

  const actionList = [
    (data) => (
      <IconButton onClick={() => setEditClusterFlowData(data)} variant="edit">
        <span style={{ fontSize: '13px', padding: '0 6px' }}>Edit</span>
      </IconButton>
    ),
    (data) => (
      <IconButton
        onClick={() =>
          navigate(`/admin/clusterFlow/test`, {
            state: { clusterArray: data.clusterArray },
          })
        }
        variant="test"
      >
        <span style={{ fontSize: '13px', padding: '0 6px' }}>Test Flow</span>
      </IconButton>
    ),
  ];

  if (isLoading) {
    return (
      <AdminLayout pageTitle="Clusters Flow" activeTab="clustersFlow">
        <LoaderWrapper>Loading...</LoaderWrapper>
      </AdminLayout>
    );
  }

  if (isError) {
    return (
      <AdminLayout pageTitle="Clusters Flow" activeTab="clustersFlow">
        <LoaderWrapper>Oops! Error Encountered</LoaderWrapper>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout activeTab="clusterFlows">
      <UsersContainer>
        <UsersHeader>
          <IntlMessages id="nav.clustersFlow" defaultMessage="Clusters Flow" />
          <PrimaryButton onClick={() => setAddClusterFlowData(true)}>
            Add Cluster Flow
          </PrimaryButton>
        </UsersHeader>

        <Table
          data={tableData}
          columns={columns}
          hasFooter={true}
          actions={actionList}
          page={page}
          pageSize={perPage}
          prevPage={() => setPage((p) => Math.max(0, p - 1))}
          nextPage={() => setPage((p) => p + 1)}
          total={total}
        />

        {editClusterFlowData && (
          <ClusterFlowCreateAndUpdateModal
            onClose={() => setEditClusterFlowData(null)}
            isEdit={true}
            flowId={editClusterFlowData._id}
            initialData={{
              name: editClusterFlowData.name,
              description: editClusterFlowData.description,
              clusterArray: editClusterFlowData.clusterArray || [],
            }}
          />
        )}
        {addClusterFlowData && (
          <ClusterFlowCreateAndUpdateModal
            onClose={() => setAddClusterFlowData(false)}
            isEdit={false}
            flowId={null}
          />
        )}
      </UsersContainer>
    </AdminLayout>
  );
};

export default ClustersFlow;
